<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Greg McEnnally was a Science and Maths teacher for many years in Australia and Papua New Guinea. Subsequently, he shifted to teaching English as a second language because of its need in Indonesia. From there he moved to China, teaching in Fuzhou, Fujian Province, Tongren in Guizhou Province and Chongqing. This book is about his experiences teaching in Tongren between 2008 and 2011.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b10ec6b6